












































import { Component, Prop, Vue } from 'vue-property-decorator';
import ColorPicker from './TypeCard/ColorPicker.vue';
import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';

@Component({
  components: {
    ColorPicker,
  },
})
export default class TypeCard extends Vue {
  @Prop() private type!: any;

  private deleteLeaveType() {
    request('delete', `leave-types/` + this.type.id).then(() => {
      this.$store.dispatch('leaveTypes/updateLeaveTypes', { force: true });
    });
  }

  private handleFieldChange(value: string, field: string) {
    request('put', `leave-types/${this.type.id}`, {
      ...this.type,
      [field]: value,
    }).then(() => {
      this.$store.dispatch('leaveTypes/updateLeaveTypes', { force: true });
    });
  }
}
